export default function batteryPassportTranslate(en) {
  const ZhEnSwitch = {
    zh: {
      DigitalBatteryPassport: "电池护照",
      UniqueIdentifier: "电池护照唯一标识码",
      GenerationTime: "生成时间",
      BlockchainNotarization: "区块链存证",
      Classification: "类型",
      ModelIdentification: "型号",
      Weight: "重量",
      Battery: "电池信息",
      Material: "材料信息",
      ESG: "ESG信息",
      Traceability: "供应链数据追溯",
      RegisteredTradeMark: "注册商标",
      SeparateCollection: "认证分类",
      Capacity: "电池容量",
      RegisteredTradeName: "注册名称",
      "Non-rechargeable": "能否充电",
      UsableExtinguishingAgent: "可用灭火器",
      Chemistry: "化学性质",
      "Hazardous Substance": "电池中除汞、镉或铅以外的有害物质",
      "Basic Information": "基础信息",
      "Batch Number": "生产批次",
      "Manufacturing Date": "生产日期",
      "Manufacturer Name": "制造商名称",
      "Manufacturing Address": "生产地址",
      "Manufacturer Email Address": "联系方式",
      "Manufacturer Postal Address": "制造商地址",
      "Manufacturer Web": "制造商官网",
      "Detailed Parameter": "详细参数",
      "Critical Raw Materials": "电池中浓度超过 0.1%（重量百分比）的关键原材料",
      "C-rate of Relevant": "相关循环寿命测试的 crate",
      "Capacity Threshold for Exhaustion":
        "电量耗尽的容量阈值(仅适用于电动汽车电池)",
      "Temperature Range (when not in use)": "温度范围",
      "Expected Lifetime (expressed in cycles)": "预期寿命",
      "Rated Capacity (in Ah)": "额定容量",
      "Power Capability": "功率容量",
      "Commercial Warranty Period": "商业保修期",
      "Round Trip Energy Efficiency": "能效",
      "Internal Resistance": "内部电阻",
      "Battery Cell": "电池组件",
      "Battery Pack": "电池包",
      Voltage: "电池电压",
      "Nominal Voltage": "额定电压",
      "Temperature Range": "运行温度",
      "Minimal Voltage": "最小电压",
      "Maximum Voltage": "最大电压",
      "Product Name": "产品名称",
      "Carbon Emission": "碳排放",
      "Carbon Footprint": "碳足迹核算原始数据类型",
      "Responsible Sourcing": "负责任采购",
      Manufacturer: "生产商",
      "Recycled Content": "回收材料名称",
      "Percentage Share": "占比",
      "Waste Battery Management": "废电池管理说明",
      "Methods and Recommendations": "用户使用电池的方法和建议",
      "Practices for Separate": "用户分类收集废电池的做法",
      WasteBattery: "废电池回收说明",
      "Safety Instructions": "废电池处理安全说明",
      "Meaning of Battery": "电池标签和符号的含义",
      "Impact of Hazardous Substances": "电池中有害物质的影响",
      "Carbon Footprint of Battery": "电池产品碳足迹",
      Distribution: "分销阶段",
      "EU declaration of conformity": "欧盟合格声明",
      "General Information on Batteriesy": "电池一般信息",
      "View More Information": "查看更多信息",
      "Battery Carbon Footprint Units": "电池碳足迹单位",
      "Carbon Footprint Performance Class": "碳足迹性能等级",
      "Battery Raw Material Information": "电池原材料信息",
      "Battery ESG Information": "电池ESG相关信息",
      "Raw Material Processing": "原材料加工预处理阶段",
      "Production and Processing Stage": "生产加工阶段",
      "End of life and recycling": "生命末期阶段",
      "Main product production": "生产制造阶段",
      "Current Status: Battery in Use": "当前电池在使用状态",
    },
    en: {
      "Batch Number": "Batch Number",
      "Minimal Voltage": "Minimal Voltage",
      "Main product production": "Main product production",
      "Current Status: Battery in Use": "Current Status: Battery in Use",
      "Raw Material Processing":
        "Raw Material Processing and Pre-treatment Stage",
      "End of life and recycling": "End of life and recycling",
      "Production and Processing Stage": "Production and Processing Stage",
      "Battery ESG Information": "Battery ESG Information",
      "Battery Raw Material Information": "Battery Raw Material Information",
      "Carbon Footprint Performance Class":
        "Carbon Footprint Performance Class",
      "Battery Carbon Footprint Units": "Battery Carbon Footprint Units",
      "View More Information": "View More Information",
      "General Information on Batteriesy": "General Information on Batteries",
      "EU declaration of conformity": "EU Declaration of Conformity",
      Distribution: "Distribution",
      "Carbon Footprint of Battery": "Battery Carbon Footprint",
      "Impact of Hazardous Substances": "Impact of Hazardous Substances",
      "Meaning of Battery": "Meaning of Battery Label and Symbol",
      "Carbon Footprint": "Carbon Footprint Accounting Raw Data Type",
      "Safety Instructions":
        "Safety Instructions for Disposal of Waste Batteries",
      WasteBattery: "Waste Battery Recycling Instructions",
      "Practices for Separate":
        "Practices for Separate Collection of Waste Batteries",
      "Responsible Sourcing": "Responsible Sourcing",
      "Percentage Share": "Percentage Share",
      "Methods and Recommendations":
        "Methods and Recommendations for End-users of Batteries",
      Manufacturer: "Manufacturer",
      "Waste Battery Management": "Waste Battery Management",
      "Recycled Content": "Recycled Content",
      "Carbon Emission": "Carbon Emission",
      "Product Name": "Product Name",
      "Maximum Voltage": "Maximum Voltage",
      "Temperature Range": "Temperature Range",
      "Nominal Voltage": "Nominal Voltage",
      Voltage: "Voltage",
      "Battery Pack": "Battery Pack",
      "Battery Cell": "Battery Cell",
      "Internal Resistance": "Internal Resistance",
      "Round Trip Energy Efficiency": "Round Trip Energy Efficiency",
      "Commercial Warranty Period": "Commercial Warranty Period",
      "Power Capability": "Power Capability",
      "Rated Capacity (in Ah)": "Rated Capacity (in Ah)",
      "Expected Lifetime (expressed in cycles)":
        "Expected Lifetime (expressed in cycles)",
      "Temperature Range (when not in use)":
        "Temperature Range (when not in use)",
      "Capacity Threshold for Exhaustion":
        "Capacity Threshold for Exhaustion (only for electric vehicle batteries)",
      "C-rate of Relevant": "C-rate of Relevant Cycle-life Test",
      "Critical Raw Materials":
        "Critical Raw Materials (in a concentration of more than 0,1 %, weight by weight)",
      "Detailed Parameter": "Detailed Parameter",
      "Manufacturer Web": "Manufacturer Web",
      "Manufacturer Postal Address": "Manufacturer Postal Address",
      "Manufacturer Email Address": "Manufacturer Email Address",
      "Manufacturing Address": "Manufacturing Address",
      "Manufacturer Name": "Manufacturer Name",
      "Manufacturing Date": "Manufacturing Date",
      "Basic Information": "Basic Information",
      UsableExtinguishingAgent: "Usable Extinguishing Agent",
      "Hazardous Substance":
        "Hazardous Substance (other than mercury, cadmium or lead)",
      "Non-rechargeable": "Rechargeable or Non-rechargeable",
      RegisteredTradeName: "Registered Trade Name",
      Capacity: "Capacity",
      Chemistry: "Chemistry",
      SeparateCollection: "Separate Collection",
      RegisteredTradeMark: "Registered Trade Mark",
      Traceability: "Traceability",
      ESG: "ESG",
      Material: "Material",
      Battery: "Battery",
      DigitalBatteryPassport: "Digital Battery Passport",
      UniqueIdentifier: "Unique Identifier",
      GenerationTime: "Generation Time",
      BlockchainNotarization: "Blockchain Notarization",
      Classification: "Classification",
      ModelIdentification: "Model Identification",
      Weight: "Weight",
    },
  };
  return en ? ZhEnSwitch.en : ZhEnSwitch.zh;
}
